import { render } from "./PaymentSuccessful.vue?vue&type=template&id=88f201ca&scoped=true"
import script from "./PaymentSuccessful.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessful.vue?vue&type=script&lang=js"

import "./PaymentSuccessful.vue?vue&type=style&index=0&id=88f201ca&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88f201ca"]])

export default __exports__